// Ajax cart JS for Drawer and Cart Page
class quickShop extends HTMLElement {
    constructor() {
      super();

      this.closeBy = this.querySelector('.close-quickshop');
      this.bindEvents();
      // this.updateEvents();

      if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }
  
    /**
     * Escape Click event to close drawer when focused within Cart Drawer
     *
     * @param {event} Event instance
     */
    onKeyUp(event) {
      if(event.code.toUpperCase() !== 'ESCAPE') return;
      this.querySelector('.close-quickshop').dispatchEvent(new Event('click'));
    }

    /**
     * bind click and keyup event to Cart Icons
     * bind keyUp event to Cart drawer component
     * bind Other inside element events
     *
     */
    bindEvents() {
      this.openeBy = document.querySelectorAll('.quickshop--button');
      this.openeBy.forEach(btn => btn.addEventListener('click', this.openQuickShop.bind(this)));
      this.addEventListener('keyup', this.onKeyUp.bind(this));
    }
  
    updateEvents(){
      this.openeBy = document.querySelectorAll('.quickshop--button');
      if(this.openeBy) this.openeBy.forEach(btn => btn.addEventListener('click', this.openQuickShop.bind(this)));
    }

    async _loadQuickShop(handle){
      let requestURL = `/products/${handle}?view=quickshop&sections=template-product-quickshop`;
      const response = await fetch(requestURL);
      const quickShopData = await response.json();
      return quickShopData['template-product-quickshop'];
    }

    /**
     * Open QuickShop modal and add focus to modal container
     *
     * @param {event} Event instance
     */
    openQuickShop(event) {
      event.preventDefault();
      const _this = event.currentTarget;
      const handle = _this.dataset.handle
      if(!handle) return;
      
      this._loadQuickShop(handle).then(quickShopData => {
        this.innerHTML = quickShopData;

        var productDataJSON = JSON.parse(document.querySelector('#PopupModal-quickshop [data-productJSON]').textContent);
        var productVariants = productDataJSON.product_variants;
        var productOptions = productDataJSON.product_options;
        var productFirstAvailable = productDataJSON.product_first_available;
        var quickShopEle = this;

        Shopify.optionsMap = {};
        this.defaultProductOptionSetup(productVariants,productOptions);
        this.checkOptionSelection(quickShopEle);

        this.querySelector('.modal').classList.add('open');
        siteOverlay.prototype.showOverlay();
        if(this.querySelector('.product-title')) Utility.forceFocus(this.querySelector('.product-title'));
        if(this.querySelector('[data-sku_value]')) this.querySelector('[data-sku_value]').innerHTML = `${productFirstAvailable.sku}`;
        this.closeBy = this.querySelector('.close-quickshop');
        if(this.closeBy) this.closeBy.addEventListener('click', this.closeQuickShop.bind(this));
        Utility.trapFocus(this, this.closeBy);
        // this.renderSWatches();
        if(event){
          _this.setAttribute('aria-expanded', true);
        }
      });
    }

    /**
     * Open QuickShop and Remove focus from modal container
     *
     * @param {event} Event instance
     */
    closeQuickShop(event, elementToFocus = false) {
      if (event !== undefined) {
        event.preventDefault();
        this.innerHTML = '';
        quickShopSlider = null;
        
        siteOverlay.prototype.hideOverlay();
        let openByEle = document.querySelector('.quickshop--button[aria-expanded="true"]');
        openByEle.setAttribute('aria-expanded', false);
        Utility.removeTrapFocus(elementToFocus);
        Utility.forceFocus(openByEle);
      }
    }

    manageVariantSlider(variant){
      const mediaJSON = JSON.parse(document.querySelector('#PopupModal-quickshop [data-productMedia]').innerHTML)
      const productContainer = document.querySelector('#PopupModal-quickshop .product-details-wrapper');
      const productSliderType = productContainer.dataset.slider_type;

      if(productSliderType == 'color-based'){
          const currentVariant = variant;
          const colorName = currentVariant.option1.toLowerCase();
          const colorMedia = [];
          mediaJSON.forEach(media => {
              let mediaAlt = media.alt;
              if(mediaAlt) mediaAlt = mediaAlt.toLowerCase();
              if(mediaAlt == colorName) colorMedia.push(media);
          });

          const sliderParent = document.querySelector('#PopupModal-quickshop [data-main-slider]');
          if(!sliderParent || colorMedia.length <= 0) return;

          let slidesHTML = '';
          colorMedia.forEach(function(i,v){
              let imageAlt = i.alt.toLowerCase();
              if(imageAlt == colorName){
                  if(i.media_type == "external_video"){
                    slidesHTML+= `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" role="treeitem">
                        <div class="custom-video-container">
                            <custom-video class="placement--grid" data-video-type="${i.host}" data-video-id="${i.external_id}" data-placement="grid" data-autoplay="true" data-controls="true">
                                <div class="cta-btn" data-aos="hero">
                                    <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                        <i class="icon-play text-body"></i>
                                    </button>
                                    <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                        <i class="icon-pause"></i>
                                    </button>
                                </div>
                                <div class="content-section">
                                    <div class="poster-image">
                                        <img class="img-fluid"
                                        src="${i.preview_image.src}"
                                        alt="${i.alt}"/>
                                    </div>
                                </div>
                                <div class="video-section" tabindex="0"></div>
                            </custom-video>
                        </div>
                    </div>`;
                  }else if(i.media_type == "video"){
                    slidesHTML+= `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" role="treeitem">
                        <div class="custom-video-container">
                            <custom-video class="placement--grid" data-video-type="local" data-video-id="${i.sources[0].url}" data-placement="grid" data-autoplay="true" data-controls="true">
                                <div class="cta-btn">
                                    <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                        <i class="icon-play text-body"></i>
                                    </button>
                                    <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                        <i class="icon-pause"></i>
                                    </button>
                                </div>
                                <div class="content-section">
                                    <div class="poster-image">
                                        <img class="img-fluid"
                                        src="${i.preview_image.src}"
                                        alt="${i.alt}"/>
                                    </div>
                                </div>
                                <div class="video-section" tabindex="0"></div>
                            </custom-video>
                        </div>
                    </div>`;
                  }else{
                    slidesHTML+= `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" data-media-url="${i.src}" role="treeitem">
                        <img class="img-fluid"
                        src="${i.preview_image.src}"
                        alt="${i.alt}"/>
                    </div>`;
                  }
              }
          });

          let finalHTML = `<slider-element class="swiper-container carousel">
                              <div class="swiper swiper-slider product-carousel quickshop-carousel"
                                  data-slider='{
                                          "loop": false,
                                          "slidesPerView": "1",
                                          "spaceBetween": 15,
                                          "grabCursor": true,
                                          "navigation": {
                                              "nextEl": ".swiper-button-next",
                                              "prevEl": ".swiper-button-prev"
                                          },
                                          "pagination": {
                                              "el": ".swiper-pagination"
                                          }
                                      }' role="tree">
                                  <div class="swiper-wrapper" >${slidesHTML}</div>
                                  <div class="swiper-pagination"></div>
                              </div>
                          </slider-element>`;
          sliderParent.innerHTML= finalHTML;
      }
    }

    // setup product option global data.
    defaultProductOptionSetup(productVariants,productOptions) {
      Shopify.arrayIncludes = function(e, t) {
          for (var n = 0; n < e.length; n++)
              if (e[n] == t)
                  return !0;
          return !1
      };

      Shopify.uniq = function(e) {
          for (var t = [], n = 0; n < e.length; n++)
              Shopify.arrayIncludes(t, e[n]) || t.push(e[n]);
          return t
      };

      for (var i = 0; i < productVariants.length; i++) {
          var variant = productVariants[i];
          if (variant.available) {

              // Gathering values for the 1st drop-down.
              if (productOptions.length === 1) {
                  Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
                  Shopify.optionsMap['root'].push(variant.option1);
                  Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
              }

              // Gathering values for the 2nd drop-down.
              if (productOptions.length > 1) {
                  var key = variant.option1;
                  Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                  Shopify.optionsMap[key].push(variant.option2);
                  Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
              }

              // Gathering values for the 3rd drop-down.
              if (productOptions.length === 3) {
                  var key = variant.option1 + ' / ' + variant.option2;
                  Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                  Shopify.optionsMap[key].push(variant.option3);
                  Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
              }
          }
      }
    }

    // add disable class to input label
    addDisableClassToOptionLable(quickShopEle) {
        var optionData = quickShopEle.querySelectorAll('[data-format] .js.product-form__input');
        if (optionData.length > 0) {
            optionData.forEach((el, i) => {

                var optionElement = el.querySelectorAll('.list-unstyled li');
                if (optionElement.length > 0) {
                    optionElement.forEach((item, i) => {
                        item.querySelector('label').classList.add('is--disable');
                    })
                }
            })
        }
    }

    checkOptionSelection(quickShopEle) {
        this.addDisableClassToOptionLable(quickShopEle);
        var optionsCount = quickShopEle.querySelectorAll('[data-format] .js.product-form__input').length;

        if (optionsCount > 0 && Shopify.optionsMap !== undefined) {
            if (optionsCount === 1) {
                Shopify.optionsMap["root"].forEach((el, i) => {
                    quickShopEle.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.remove('is--disable');
                })
            } else if (optionsCount === 2) {
                var option_1 = quickShopEle.querySelector('[data-format] .js.product-form__input:first-child .list-unstyled input:checked').value;
                var option_2 = quickShopEle.querySelector('[data-format] .js.product-form__input:last-child .list-unstyled input:checked').value;
                if (Shopify.optionsMap[option_1] != undefined) {
                    Shopify.optionsMap[option_1].forEach((el, i) => {
                        quickShopEle.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.remove('is--disable');
                    })
                }

                for (var key in Shopify.optionsMap) {
                    if (Shopify.optionsMap[key].indexOf(option_2) != -1) {
                        quickShopEle.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${key}"]`).classList.remove('is--disable');
                    }
                }
            } else if (optionsCount === 3) {
                var option_1 = quickShopEle.querySelector('[data-format] .js.product-form__input:first-child .list-unstyled input:checked').value;
                var option_2 = quickShopEle.querySelector('[data-format] .js.product-form__input:nth-child(2) .list-unstyled input:checked').value;
                var option_3 = quickShopEle.querySelector('[data-format] .js.product-form__input:last-child .list-unstyled input:checked').value;
                if (Shopify.optionsMap[option_1] != undefined) {
                    Shopify.optionsMap[option_1].forEach((el, i) => {
                        var option2 = Shopify.optionsMap[option_1][i];
                        quickShopEle.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${option2}"]`).classList.remove('is--disable');
                    })
                }

                var option2Data = `${option_1} / ${option_2}`;
                Shopify.optionsMap[option2Data].forEach((el, i) => {
                    var option3 = Shopify.optionsMap[option2Data][i];
                    quickShopEle.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${option3}"]`).classList.remove('is--disable');
                })

                var customOption1 = [];
                var firstSwatchOptions = quickShopEle.querySelectorAll('[data-format] .js.product-form__input:first-child .list-unstyled li');
                if (firstSwatchOptions.length > 0) {
                    firstSwatchOptions.forEach((optionEl, i) => {
                        customOption1.push(optionEl.querySelector('label').getAttribute('title'));
                    })
                }
                customOption1.forEach((el, i) => {
                    var customOptionName = `${el} / ${option_2}`;
                    if (Shopify.optionsMap[customOptionName] != undefined && Shopify.optionsMap[customOptionName].indexOf(option_3) != -1) {
                        quickShopEle.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.remove('is--disable');
                    } else {
                        quickShopEle.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.add('is--disable');
                    }
                })

                var customOption2 = [];
                var firstSwatchOptions = quickShopEle.querySelectorAll('[data-format] .js.product-form__input:nth-child(2) .list-unstyled li');
                if (firstSwatchOptions.length > 0) {
                    firstSwatchOptions.forEach((optionEl, i) => {
                        customOption2.push(optionEl.querySelector('label').getAttribute('title'));
                    })
                }
                customOption2.forEach((el, i) => {
                    var customOption2Name = `${option_1} / ${el}`;
                    if (Shopify.optionsMap[customOption2Name] != undefined && Shopify.optionsMap[customOption2Name].indexOf(option_3) != -1) {
                        quickShopEle.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.remove('is--disable');
                    } else {
                        quickShopEle.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.add('is--disable');
                    }
                })
            }
        }
    }
}
customElements.define("quick-shop", quickShop);
  